<script lang="ts">
import { defineComponent, ref, watch } from 'vue'
import CompanyTable from '../components/CompanyTable.vue'

export default defineComponent({
  name: 'company-list',
  data() {
    return {
      searchTerm: '',
    }
  },
  components: { CompanyTable },
})
</script>

<template>
  <main class="flex-1">
    <div class="py-6">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
        <h1 class="text-2xl font-semibold text-gray-900">Zoznam spoločností</h1>
      </div>
      <company-table :hladaj="searchTerm"></company-table>
    </div>
  </main>
</template>
